"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendGatewayAjaxRequest = sendGatewayAjaxRequest;
var _demoRequest = require("./demo-request");
var _request = require("./request");
var _requestOptions = require("./request-options");
var _coreConfig = _interopRequireDefault(require("../core-config"));
var _coreLog = _interopRequireWildcard(require("../core-log"));
var _coreLogger = require("../core-logger");
var _coreMerge = _interopRequireDefault(require("../core-merge"));
var _coreSanitize = _interopRequireDefault(require("../core-sanitize"));
var _coreUuid = _interopRequireDefault(require("../core-uuid"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/*
* Copyright (c) 2020 Wells Fargo, All rights reserved.
*
* This software is the confidential and proprietary information of Wells Fargo
* bank. ('Confidential Information'). You shall not disclose such Confidential
* Information and shall use it only in accordance with the terms of the license
* agreement you entered into with WellsFargo.
*/

/**
 * Updates the stored session token with the new one returned as a response header
 * in the response object
 *
 * @param {object} response The response object
 */
function updateSessionToken(response) {
  if (response && response.headers) {
    // save off the new session-token
    var newSessionToken = _coreSanitize["default"].sanitizeAll(response.headers['session-token']);
    if (newSessionToken) {
      _coreConfig["default"].get(_coreConfig["default"].internal).sessionToken = newSessionToken;
    }
  }
}

/**
 * Sends AJAX request to a WF Gateway API.
 * Adds headers required by WF Gateway API.
 *
 * @param {string} url The URL of the AJAX request handler
 * @param {object} options JS object containing the request payload and
 * result callbacks
 */
function sendGatewayAjaxRequest(url, options) {
  var defaults = {
    'headers': {
      'Content-Type': 'application/json; charset=UTF-8',
      'Pragma': 'no-cache'
    }
  };
  var mergedOptions = _coreMerge["default"].merge({}, defaults, options);
  var opts = (0, _requestOptions.createBackendRequestOptions)('sendGatewayAjaxRequest', mergedOptions);
  if (!opts) {
    return;
  }

  // set client-request-id
  opts.headers['client-request-id'] = _coreUuid["default"].uuid();
  if (_coreConfig["default"].get(_coreConfig["default"].internal).sessionToken) {
    opts.headers['session-token'] = _coreConfig["default"].get(_coreConfig["default"].internal).sessionToken;
  }

  // add response time log to Gateway requests
  (0, _coreLogger.isGatewayLogAPIPathUrl)(url) && (0, _coreLog.addResponseTimeLog)(url, opts);

  // proxy the success & failure callbacks to update the session token
  var originalSuccess = opts.success;
  opts.success = function (data, textStatus, response) {
    // update the session token
    updateSessionToken(response);
    originalSuccess(data, textStatus, response);
  };
  var originalFailure = opts.failure;
  opts.failure = function (response, textStatus, message) {
    // update the session token
    updateSessionToken(response);
    originalFailure(response, textStatus, message);
  };
  _coreLog["default"].log('making AJAX call to: ' + url);
  if ((0, _demoRequest.isDemoMode)(opts.serviceKey)) {
    (0, _demoRequest.demoRequest)(opts);
  } else {
    (0, _request.ajaxRequest)(url, opts);
  }
}
//# sourceMappingURL=gateway-request.js.map